import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges,} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { ReportsService } from 'src/app/services/reports.service';
import { SalesTrendsListComponent } from '../sales-trends-list/sales-trends-list.component';
import { SalesTrendsPopupInfoComponent } from '../sales-trends-popup-info/sales-trends-popup-info.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-kpi-dashboard',
  templateUrl: './kpi-dashboard.component.html',
  styleUrls: ['./kpi-dashboard.component.scss']
})
export class KpiDashboardComponent implements OnInit, OnChanges,OnDestroy {
@Input() label;
@Input() id;
@Input() page;
@Input()isApplyFilter: boolean =false;
dashboardInfo;
@Input()availableFilters;
@Input() productId;
public unique_key: number;
public parentRef: SalesTrendsListComponent;
dateInfo: any[] = [];
showGraph: boolean = false;
private destroy$ = new Subject<void>();

dateArray : any[] = [
{
  to: new Date(),
  from: new Date(new Date().getTime() - this.getDaysAgo(30)),
  label: '1-30 Days'
},
{
  to: new Date(new Date().getTime() - this.getDaysAgo(31)),
  from: new Date(new Date().getTime() - this.getDaysAgo(60)),
  label: '31-60 Days',
},
{
  to: new Date(new Date().getTime() - this.getDaysAgo(61)),
  from: new Date(new Date().getTime() - this.getDaysAgo(90)),
  label: '61-90 Days',
},
{
  to: new Date(new Date().getTime() - this.getDaysAgo(91)),
  from: new Date(new Date().getTime() - this.getDaysAgo(180)),
  label: '91-180 Days',
},
{
  to: new Date(new Date().getTime() - this.getDaysAgo(181)),
  from: new Date(new Date().getTime() - this.getDaysAgo(365)),
  label: '181-365 Days',
}
]
  startDate: any;
  endDate: any;
  data: any;
  dialogRefs: any;
  showDisable:boolean=true;
  dialogRef:any;
  spin:boolean;

  constructor(private reportService: ReportsService,
    private dashboardService: DashboardService,
    private router: Router,
    private dialog:MatDialog,
    private snackBar: MatSnackBar,
    private datePipe:DatePipe) 
    {
    this.dashboardService.selectedDate$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res) {      
        this.startDate = res.startDate;
        this.endDate = res.endDate;
        this.spin = res?.spinner;
        this.dialogRef = res?.dialogRef; 
        setTimeout(() => {    
        if((this.router.url.includes('kpi') && this.id == res.isKpiDashboardId) || this.productId && this.id == res.isKpiDashboardId) 
        this.getDashboardDetails(res);
        });
      }
    })
  }

  ngOnInit(): void {
    this.getDashboardDetails()
  }
     
  ngOnChanges(changes: SimpleChanges): void {
    if(this.isApplyFilter){
     this.getDashboardDetails()
    }
   }

  getDashboardDetails(res?){
    let selectedAccount =this.availableFilters?.find(
      (filter) => filter?.filterName === "Channel"
    )?.currentValue;
    this.dateInfo = this.dateArray.filter((res)=> res.label == this.label);
    let payload : any;
     payload ={
      dateFrom :this.datePipe.transform(this.dateInfo[0].from, 'yyyy-MM-ddT00:00:00'),
      dateTo : this.datePipe.transform(this.dateInfo[0].to, 'yyyy-MM-ddT23:59:59'),
    }
    if(res) {
      payload ={
        dateFrom : this.datePipe.transform(res.startDate, 'yyyy-MM-ddT00:00:00'),
        dateTo :  this.datePipe.transform(res.endDate, 'yyyy-MM-ddT23:59:59'),
      }
    }
   
    if(this.productId){
      this.getProductAnalyticsDetail(payload);
    } else{
      if(selectedAccount) payload.account=selectedAccount;
      this.getKpiDashboardDetail(payload);
    }
  }

  getKpiDashboardDetail(payload){
    this.reportService.kpiDashboardDetails(payload).pipe(takeUntil(this.destroy$)).subscribe({
     next: (res) => {
     this.dashboardInfo = res;
     this.spin = false;
     this.dialogRef?.close();
    },
    error: (err) => {
      this.spin = false;
      this.dialogRef?.close();
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title:err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        });
     }
   })
  }


  getProductAnalyticsDetail(payload){
    payload.productId = this.productId;
    this.reportService.KpiProductDashboard(payload).pipe(takeUntil(this.destroy$)).subscribe({
     next: (res:any) => {
      this.dashboardInfo = res;
      this.spin = false;
      this.dialogRef?.close();
     },
     error: (err) => {
       this.spin = false;
       this.dialogRef?.close();
       this.snackBar.openFromComponent(SnackbarComponent,
         {
           duration: 3000,
           horizontalPosition: 'center',
           data: {
             title:err.error?.error[0],
             action: 'Dismiss',
             type: 'error',
           },
         });
      }
    })
  }

  dateFilterChange(date){
   this.getDashboardDetails();
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  showChart(value){
    if(value == true) this.showGraph = true;
    else this.showGraph = false;
   }
 
   openDialog(e: MouseEvent,title) {
      this.dialogRefs = this.dialog.open(SalesTrendsPopupInfoComponent, {
       width: "260px",
       position: this.getDialogPosition(e),
       backdropClass: "cdk-overlay-transparent-backdrop",
       data: {
         title: title,
         data:this.dashboardInfo
       },
     })
   }

   getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 50 + "px",
      top: targetPosision.top + 15 + "px",
    };
  }

  
   getOrderDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 30 + "px",
      top: targetPosision.top + 15 + "px",
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}